import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import CoreInput from "./CoreInput";
import CustomView from "../dataDisplay/CustomView";

export default function CoreDatePicker(props) {
  const {
    id = "date",
    label = "Pickup Date",
    value,
    onChange,
    edit,
    ...restProps
  } = props;

  // console.log("&&&&&&&&&&&&&&&&&&&&&&VALUE1", moment(value));

  return edit !== false ? (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "rgba(255, 255, 255, 1)", // Adding !important for higher specificity
          },
        }}
        id={id}
        label={label}
        value={moment(value, "DD-MM-YYYY")}
        format="DD-MM-YYYY"
        onChangeValue={(value) => {
          console.log("date", value);
        }}
        onChange={(date) => {
          onChange(date ? date.format("DD-MM-YYYY") : "");
        }}
        slotProps={{ textField: { variant: "standard" } }}
        {...restProps}
      />
    </LocalizationProvider>
  ) : (
    <CustomView label={props.label} value={props.value} />
  );
}
